/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { RESOURCE_TYPES } from "@adapptio/lib-core";
import { IEditor } from "../../IEditor";
import { ReadmeEditorView } from "./ReadmeEditorEdit/ReadmeEditorView";
import { ReadmeEditorMain } from "./ReadmeEditorEdit/components/ReadmeEditorMain";
import { README_EDITOR_VIEWS } from "./types";
import { registerCommands } from "./Commands";
import { registerKeyBindings } from "./KeyBindings";
import { registerMenus } from "./Menus";
import { CMD } from "../../commands/CMD";

export function ReadmeEditorModule(dc: IEditor): void {
	dc.get("logger").debug("ReadmeEditor module enabled.");

	const resourceSvc = dc.get("resourceService");
	const viewSvc = dc.get("viewService");

	viewSvc.registerView(README_EDITOR_VIEWS.EDIT, ReadmeEditorView, ReadmeEditorMain);

	resourceSvc.registerResourceView(RESOURCE_TYPES.README, README_EDITOR_VIEWS.EDIT);
	resourceSvc.registerResourceCreateCommand(RESOURCE_TYPES.README, CMD.README_EDITOR.CREATE.OPEN);

	registerCommands(dc);
	registerKeyBindings(dc);
	registerMenus(dc);
}
